// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:d464a0a3-0604-49c9-adf0-0c9fd6ce50c9",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_75Ohu6Ha0",
    "aws_user_pools_web_client_id": "2137vd0ocapqt2op4qni7mbqni",
    "oauth": {},
    "aws_content_delivery_bucket": "mkserverless-20191229014336-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://d2srzceohu1g7i.cloudfront.net"
};


export default awsmobile;
